<template>
  <div class="row" >
    <el-drawer
      title=""
      :visible.sync="showReservations"
      direction="btt"
      :before-close="getBookings"
      size="90%"
      :destroy-on-close="true"
    >
      <div class="">
        <reservations-list
          :booking="selected"
          v-if="selected"
          @close="getBookings"
        ></reservations-list>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showMessages"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div class="">
        <booking-messages-list
          :booking="selected"
          v-if="selected"
          @close="getBookings"
        ></booking-messages-list>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showTransfer"
      direction="btt"
      :before-close="getBookings"
      size="90%"
      :destroy-on-close="true"
    >
      <div class="">
        <booking-transfer
          :booking="selected"
          v-if="selected"
          @save="getBookings"
        ></booking-transfer>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showChangeVessel"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div>
        <change-vessel-form
          :booking="selected"
          v-if="selected"
          @save="getBookings"
        ></change-vessel-form>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showExtraSeats"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div class="container">
        <booking-extra-seats
          :booking="selected"
          v-if="selected"
          @close="getBookings"
        ></booking-extra-seats>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showPassengers"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div>
        <booking-tickets-list :booking="selected"></booking-tickets-list>
      </div>
    </el-drawer>

    <el-drawer
      title=""
      :visible.sync="showStatus"
      direction="btt"
      :before-close="handleClose"
      size="90%"
      :destroy-on-close="true"
    >
      <div>
        <booking-update-status-form
          :booking="selected"
          v-if="selected"
          @save="getBookings()"
        ></booking-update-status-form>
      </div>
    </el-drawer>

    <div class="col-lg-12 card">
      <div class="card-header">
        <div class="category">Bookings</div>
      </div>
      <div class="card-body row">
        <div class="col-lg-8 mb-2">
          <!-- <el-select class="" v-model="route_code" placeholder="Search by Route" style="width: 100%;">
            <el-option :value="route.code" :label="route.code" v-for="route in routes" :key="route.code">{{ route.code
              }}</el-option>
          </el-select> -->
         

          <el-checkbox-group
            v-model="route_codes"
            class="route-buttons"
            @change="setRoutes"
          >
          <el-checkbox-button
             label="CLEAR"
            >
              CLEAR
            </el-checkbox-button>
            <el-checkbox-button
              v-for="route in routes"
              :key="route.code"
              :label="route.code"
            >
              {{ route.code }}
            </el-checkbox-button>
          </el-checkbox-group>
        </div>
        <div class="col-md-12">
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="Pick a day"
            class="form-group"
            size="small"
            
          >
          </el-date-picker>
                              <el-button @click="getBookings">REFRESH</el-button>

        </div>
        <div class="col-lg-1">

        </div>
        <!-- <div class="col-lg-3">
          <div class="pull-right" style="width: 100%;">
            <fg-input class="input-sm" placeholder="Search" v-model="term" addon-right-icon="nc-icon nc-zoom-split">
            </fg-input>
          </div>
        </div> -->
        <div class="col-xl-12 mt-2">
          <div class="row">
            <div
              class="col-lg-12 col-md-12 col-sm-12 mb-2"
              v-for="booking in bookings"
              :key="booking.id"
            >
              <BookingView
                :booking="booking"
                @handleDisable="handleDisable(booking, $event)"
                @handleAllowOnline="handleAllowOnline(booking)"
                @handleShowReservations="handleShowReservations(booking)"
                @handleShowMessages="handleShowMessages(booking)"
                @handleTransfer="handleTransfer(booking)"
                @handleExtraSeats="handleExtraSeats(booking)"
                @handleChangeVessel="handleChangeVessel(booking)"
                @handleIssue="handleIssue(booking)"
                @handleShowStatus="handleShowStatus(booking)"
                @handleCheckin="handleCheckin(booking)"
                @handleView="handleView(booking)"
                :can_update_locked_bookings="can_update_locked_bookings"
              />
            </div>
          </div>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">Found {{ pagination.total }} data</p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
          >
          </p-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Route } from "@/resources/route";

import { Booking } from "@/resources/booking";
import ConfirmDelete from "../../Common/ConfirmDelete.vue";
import BookingTicketsList from "./BookingTicketsList.vue";
import BookingUpdateStatusForm from "./BookingUpdateStatusForm.vue";
import ChangeVesselForm from "./ChangeVesselForm.vue";
import BookingExtraSeats from "./ExtraSeats/BookingExtraSeats.vue";
import BookingTransfer from "./BookingTransfer.vue";
import BookingMessagesList from "./Messages/BookingMessagesList.vue";
import ReservationsList from "./Reservations/ReservationsList.vue";
import BookingView from "./BookingView.vue";

export default {
  components: {
    ConfirmDelete,
    BookingTicketsList,
    BookingUpdateStatusForm,
    ChangeVesselForm,
    BookingExtraSeats,
    BookingTransfer,
    BookingMessagesList,
    ReservationsList,
    BookingView,
  },
  data() {
    return {
      showReservations: false,
      showMessages: false,
      showTransfer: false,
      showExtraSeats: false,
      showStatus: false,
      showDelete: false,
      showPassengers: false,
      bookings: [],
      routes: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 20,
        currentPage: 1,
        total: 0,
      },
      route_code: null,
      date: new Date(),
      term: null,
      showChangeVessel: false,
      user: null,
      can_update_locked_bookings: false,
      route_codes: [],
      original_routes: []
    };
  },
  watch: {
    date: function () {
      let date = this.$moment(this.date).format("YYYY-MM-DD");
      if (date != this.date) this.$router.replace({ query: { date: date } });

      if (this.pagination.currentPage == 1) {
        this.getBookings();
      } else {
        this.pagination.currentPage = 1;
      }
    },
    route_code: function () {
      this.pagination.currentPage = 1;

      // let route_code = this.$route.query.route_code

      // if (route_code != this.route_code) {
      //   this.$router.replace({
      //     query: {
      //       ...this.$route.query,
      //       route_code: this.route_code
      //     }
      //   })
      // }

      // this.getBookings()
    },
    term: function () {
      if (!this.term || this.term.length > 2) {
        this.getBookings();
      }
    },
    "pagination.perPage": function () {
      if (this.pagination.currentPage == 1) {
        this.getBookings();
      } else {
        this.pagination.currentPage = 1;
      }
    },
    "pagination.currentPage": function () {
      this.getBookings();
    },
  },
  created: function () {
    this.user = this.$store.state.user;

    // date
    const date = this.$route.query.date;
    if (date && date !== this.date) {
      this.date = date;
    }

    // route codes
    const routeCodesQuery = this.$route.query.route_codes;
    if (routeCodesQuery) {
      this.route_codes = Array.isArray(routeCodesQuery)
        ? routeCodesQuery
        : routeCodesQuery.split(",");
    }
    this.getRoutes();
  },
  methods: {
    setParams() {
      const route_codes = this.$route.query.route_codes;

      const current = Array.isArray(route_codes)
        ? route_codes.join(",")
        : route_codes;

      const next = this.route_codes.join(",");

      if (current !== next) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            route_codes: next,
          },
        });
      }
    },
    setRoutes() {
      this.route_code = null;

      if (this.route_codes.includes("CLEAR")) {
        this.route_codes = [];
      }
      
      if (this.user?.is_management) {
        if (this.route_codes.includes("ALL")) {
          this.route_codes = this.routes.map((route) => route.code);
        } else if (this.route_codes.length == this.routes.length) {
          // asssuming you have unselected all
          this.route_codes = [];
        }
      }
      
      this.setParams();

      if (this.route_codes.length) {
        this.getBookings();
      } else {
        this.bookings = []
      }
      
    },
    handleAllowOnline(booking) {
      this.$loading = true;
      Booking.allowOnline(booking.id, {
        allow_online: booking.allow_online ? 0 : 1,
      })
        .then((result) => {
          this.getBookings();
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },
    handleShowReservations(booking) {
      this.showReservations = true;
      this.selected = Object.assign({}, booking);
    },
    handleShowMessages(booking) {
      this.showMessages = true;
      this.selected = Object.assign({}, booking);
    },
    handleTransfer(booking) {
      this.showTransfer = true;
      this.selected = Object.assign({}, booking);
    },
    handleExtraSeats(booking) {
      this.showExtraSeats = true;
      this.selected = Object.assign({}, booking);
    },
    getCountByType(booking, type) {
      let total = 0;
      booking.grouped_passengers.forEach((passenger) => {
        if (type == passenger.type) total = passenger.total;
      });
      return total;
    },
    handleChangeVessel(booking) {
      this.showChangeVessel = true;
      this.selected = Object.assign({}, booking);
    },
    handleCheckin(booking) {
      this.$router.push({
        name: "CheckinPassenger",
        params: { id: booking.id },
      });
    },
    async getRoutes() {
      this.$loading = true;
      try {
        const result = await Route.get({ per_page: 999 });
        if (result.data.routes) {
          this.original_routes = result.data.routes
            this.routes = result.data.routes;

          if (this.user?.is_management) {
            this.routes.unshift({ id: "ALL", code: "ALL" });
            this.$loading = false;
          } else {
            this.route_codes = []
            this.routes.forEach( (route) => {
              this.route_codes.push(route.code)
            })
            this.getBookings()
          }
        }
      } catch (error) {
        this.$loading = false;
        // Handle error if you want
      } finally {
        
      }
    },
    background(booking) {
      let klass = "";

      switch (booking.status) {
        case 0:
          klass = "bg-light-red";
          break;
        case 2:
          klass = "bg-light-green";
          break;
        case 3:
          klass = "bg-light-gray";
          break;
      }

      return klass;
    },
    handleClose() {
      this.showDelete = false;
      this.showPassengers = false;
      this.showStatus = false;
      this.showExtraSeats = false;
      this.showChangeVessel = false;
      this.showTransfer = false;
      this.showMessages = false;
      this.showReservations = false;
    },
    handleView(model) {
      this.showPassengers = true;
      this.selected = Object.assign({}, model);
    },
    handleShowStatus(model) {
      this.showStatus = true;
      this.selected = Object.assign({}, model);
    },
    async getBookings() {
      this.handleClose();

      if (!this.route_code && !this.route_codes.length) return false;

      const params = {
        date: this.$moment(this.date).format("YYYY-MM-DD"),
        term: this.term,
        status: this.status,
        page: this.pagination.currentPage,
        per_page: 999,
        route_code: this.route_code,
        route_codes: this.route_codes,
      };

      this.$loading = true;

      try {
        const result = await Booking.get({ params });

        if (result.data.bookings) {
          this.bookings = result.data.bookings;
        }

        this.pagination = result.data.meta;
        this.can_update_locked_bookings =
        result.data.can_update_locked_bookings;
        this.$loading = false;
      } catch (error) {
        console.error("Failed to fetch bookings", error);
      } finally {
        this.$loading = false;
      }
    },
    handleDisable(booking, disable) {
      this.$loading = true;
      Booking.disable(booking.id, { disable: disable ? 1 : 0 })
        .then((result) => {
          this.getBookings();
        })
        .catch(() => {})
        .finally(() => {
          this.$loading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.route-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
</style>
